import { memo } from 'react';
import { IconHandMove } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useMapAreaCenterOffset } from '../hooks/useMapAreaCenterOffset';
import styles from './MapConfigPreview.module.css';

/** Hand icon size for the drag hint banner. */
const DRAG_HINT_ICON_SIZE = 18;

/**
 * Onboarding banner telling the user the center pin can be dragged to move the
 * map center. Sits in the visible map area (centered to the left of the open
 * SlidePanel via the shared {@link useMapAreaCenterOffset}), mirroring
 * {@link MapConfigZoomControls}. Isolated into its own component so the
 * panel-width subscription (re-renders on panel resize) never re-renders the
 * underlying `<Map>`. The caller gates mounting (pin visible and not yet
 * dragged), matching the sibling `AnchorMarker`.
 */
export const MapConfigDragHint = memo(function MapConfigDragHint() {
  const { t } = useTranslation();
  const offsetStyle = useMapAreaCenterOffset();

  return (
    <div
      className={styles.dragHint}
      style={offsetStyle}
      role="status"
      aria-live="polite"
    >
      <IconHandMove size={DRAG_HINT_ICON_SIZE} />
      <span>{t('mapSetup.center.dragHint')}</span>
    </div>
  );
});
